// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"f00bd722","631":"a469d62f","725":"706f467c","828":"6abf09ff","997":"c6adc9ac"}[chunkId] + ".chunk.js";
};